let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lPS3O")).then(() => parcelRequire('9QPix'));